import { z } from 'zod';

export const RejectSeedingProposalServiceRequestSchema = z
  .object({
    participationId: z.number().int(),
    rejectionReasonCodes: z.array(z.string().min(1)).min(1),
  })
  .describe('RejectSeedingProposalServiceRequest');

export type RejectSeedingProposalServiceRequest = z.infer<
  typeof RejectSeedingProposalServiceRequestSchema
>;

// 204 No Content — 반환값 없음.
export const RejectSeedingProposalServiceResponseSchema = z
  .void()
  .describe('RejectSeedingProposalServiceResponse');

export type RejectSeedingProposalServiceResponse = z.infer<
  typeof RejectSeedingProposalServiceResponseSchema
>;
